import styles from "../detalheEsocial.styles.module.css";
import { GRUPOS_RUBRICAS } from "../utils/gruposColunasRubricas.util";

/**
 * TXM-671 — barra "Grupos de colunas" da aba Rúbricas. INSS é sempre visível (marcado e
 * desabilitado); FGTS e IRRF começam ocultos e o usuário marca para exibir. O estado
 * mora no pai e não é persistido.
 *
 * @param {{ gruposAtivos: string[], onToggle: (idGrupo: string) => void }} props
 */
export default function BarraGruposColunas({ gruposAtivos, onToggle }) {
  return (
    <div className={styles.gruposBar} role="group" aria-label="Seleção de grupos de colunas">
      <span className={styles.gruposBarTitulo}>Grupos de colunas</span>
      {GRUPOS_RUBRICAS.map((grupo) => {
        const obrigatorio = grupo.id === "inss";
        const marcado = obrigatorio || gruposAtivos.includes(grupo.id);
        return (
          <label
            key={grupo.id}
            className={`${styles.grupoChip} ${styles[`grupoCor_${grupo.id}`]}`}
          >
            <input
              type="checkbox"
              checked={marcado}
              disabled={obrigatorio}
              onChange={() => onToggle(grupo.id)}
            />
            {grupo.rotulo}
          </label>
        );
      })}
    </div>
  );
}
